import { Link } from "react-router-dom";
import { Facebook, Phone, Mail, MapPin } from "lucide-react";

const REGIONS = ["Gippsland", "North East", "Western District", "Mallee", "Yarra Valley", "Central Highlands", "Riverina NSW", "Murray NSW"];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-thermal/15 bg-field">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/logo-stacked.png" alt="Victorian Pest and Game Services logo" className="h-14 w-auto" />
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-euca">Est. Field Ops · Victoria</p>
            </div>
            <h2 className="mt-6 font-display text-3xl font-black uppercase leading-none tracking-tight text-bone sm:text-4xl">
              Victorian Pest
              <br />
              &amp; Game Services
            </h2>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-euca">
              Professional feral animal control, farm culling programs and property
              assessments — licensed, insured and humane, across Victoria and southern NSW.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-thermal">Contact</p>
            <ul className="mt-5 space-y-4 text-sm text-bone">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-thermal" />
                <a href="tel:+61466747214" data-testid="footer-phone-link" className="transition-colors hover:text-thermal">
                  0466 747 214
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-thermal" />
                <a
                  href="mailto:mick@vicpestandgame.com.au"
                  data-testid="footer-email-link"
                  className="transition-colors hover:text-thermal"
                >
                  mick@vicpestandgame.com.au
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Facebook className="h-4 w-4 text-thermal" />
                <a
                  href="https://www.facebook.com/profile.php?id=61580276000635"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook-link"
                  className="transition-colors hover:text-thermal"
                >
                  Follow us on Facebook
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-thermal" />
                <span>Servicing Victoria &amp; Southern NSW</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-thermal">Site</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["Services", "/services", "footer-services-link"],
                ["About", "/about", "footer-about-link"],
                ["Field Work", "/gallery", "footer-gallery-link"],
                ["Assessment Tool", "/calculator", "footer-calculator-link"],
                ["Contact", "/contact", "footer-contact-link"],
              ].map(([label, to, id]) => (
                <li key={to}>
                  <Link to={to} data-testid={id} className="text-euca transition-colors hover:text-thermal">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-thermal">Operating Regions</p>
            <ul className="mt-5 space-y-3 text-sm text-euca">
              {REGIONS.map((r) => (
                <li key={r}>{r}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-thermal/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-euca">
            © 2026 Victorian Pest &amp; Game Services · ABN 98 607 232 620
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-euca">
            Firearms Cat A·B·D · Commercial Operator Licence · $20M Insured
          </p>
        </div>
      </div>
    </footer>
  );
}
